// @ts-nocheck
import { useCallback } from 'react';
import { useKeycloak } from '@react-keycloak-fork/web';
import persistor from './persistor';

export default function useAuthentication() {
    const { initialized, keycloak } = useKeycloak();
    const { authenticated } = keycloak;

    const origin = typeof window !== 'undefined' && window.location.origin ? window.location.origin : '';

    const getCurrentPath = () => {
        const { pathname, search } = window.location;
        return `${pathname}${search}`;
    };

    const methods = {
        login: useCallback(({ redirectPath }) => {
            keycloak.login({ redirectUri: `${origin}/${redirectPath || getCurrentPath()}` });
        }, [keycloak, origin]),
        getRegisterUrl: useCallback(({ redirectPath } = { redirectPath: '' }) => {
            const redirectUri = `${origin}${redirectPath || getCurrentPath()}`;
            return keycloak.createRegisterUrl({ redirectUri });
        }, [keycloak, origin]),
        logout: useCallback(({ redirectPath }) => {
            persistor.resetTokens();
            keycloak.logout({ redirectUri: `${origin}/${redirectPath || getCurrentPath()}` });
        }, [keycloak, origin]),
        updateToken: useCallback((seconds = 5) => {
            keycloak.updateToken(seconds);
        }, [keycloak]),
    };

    return { initialized, authenticated, ...methods };
}
